export default "__VITE_ASSET__BjCDHuum__"